import { i18n } from '@lingui/core';
import { defineMessage, t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeRechargingStatsPeriod } from '../../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import {
    RECHARGING_STATS_H3_DYNAMIC_LEGEND,
    RECHARGING_DAILY_H3_DYNAMIC_LEGEND,
} from '../../../constants/legends';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

// DA-14276: 4 состояния — 1d/7d/30d и seasons, все из единого источника chb_recharging_mvt.
// Переключение колонки fill-color выполняется в Map.jsx setRechargingDailyPaint.
const PERIOD_OPTIONS = [
    { value: '1d',      label: defineMessage({ message: '1 день' }) },
    { value: '7d',      label: defineMessage({ message: '7 дней' }) },
    { value: '30d',     label: defineMessage({ message: '30 дней' }) },
    { value: 'seasons', label: defineMessage({ message: 'Сезоны 2024–2025 гг.' }) },
];
const RechargingStatsLegendComponent = ({
    onChangeRechargingStatsPeriod,
    rechargingStatsPeriod,
}) => (
    <div>
        <div className={styles.legHead}>{t`Статистика переходов в Change Battery за`}:</div>
        <StandardRadioGroup
            value={rechargingStatsPeriod}
            onChange={onChangeRechargingStatsPeriod}
        >
            {PERIOD_OPTIONS.map(({ value, label }) => (
                <FormControlLabel
                    key={value}
                    className={styles.isochroneFilterLabel}
                    control={
                        <Radio
                            checked={rechargingStatsPeriod === value}
                            onChange={onChangeRechargingStatsPeriod}
                            value={value}
                            className={classnames(
                                styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: rechargingStatsPeriod === value,
                                }
                            )}
                            size='small'
                        />
                    }
                    label={i18n._(label)}
                    labelPlacement='end'
                />
            ))}
        </StandardRadioGroup>
        <LegendRenderer
            config={rechargingStatsPeriod === 'seasons'
                ? RECHARGING_STATS_H3_DYNAMIC_LEGEND
                : RECHARGING_DAILY_H3_DYNAMIC_LEGEND}
        />
    </div>
);
const mapStateToProps = ({ mapFilters: { rechargingStatsPeriod } }) => ({ rechargingStatsPeriod });
const ConnectedComponent = connect(
    mapStateToProps,
    { onChangeRechargingStatsPeriod }
)(RechargingStatsLegendComponent);

// Легенда привязана к единому слою rechargingStats (chb_recharging_mvt — сезоны + rolling 1/7/30 дней).
export const RechargingStatsLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Кол-во переходов в Change Battery`
);
